require("technical/error_page.scss");

class ErrorPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		LuckyOrangeClient.tagComponent("error")
	}

	render() {
		var which = $wr.getURLParameterByName("which") || this.props.which;
		if (which == "authentication") {
			var title = "Account Access Error";
			var description = (
				<div>
					<p>
						Whooo's Reading is temporarily having trouble accessing your account. 
						Please try refreshing the page in a few minutes. If you still experience this error after that, 
						please <a href="https://www.whooosreading.org/contact">contact us</a>.
					</p>
				</div>
			);
			var imgPath = require("owls/error-owl.png");

		} else if (which == "overdrawn") {
			var title = "Account Frozen";
			var description = (
				<div className="description">
					<p>
						Your teacher has gone over their account limits. Your account is frozen
						until your teacher fixes their roster or upgrades.
					</p>
				</div>
			);
			var imgPath = require("owls/error-owl-frozen.png");

		} else {
			var title = "Unknown Error";
			var description = (
				<div>
					<p>
						Whooo's Reading is temporarily having an unknown error for your account. 
						Please try refreshing the page in a few minutes. If you still experience this error after that, 
						please <a href="https://www.whooosreading.org/contact">contact us</a>.
					</p>
				</div>
			);
			var imgPath = require("owls/error-owl.png");
		}

		return (
			<div className="errorPage">
				<header className="pageHeader">
					<h1>{ title }</h1>
				</header>
				<div className="container text-center">
					<img src={ imgPath } />
					{ description }
				</div>
			</div>
		);
	}

	componentDidMount() {
		var redirectRefresh = $wr.getURLParameterByName("redirect_refresh");
		if (redirectRefresh == "true" && !window.wr_allowErrorPage) {
			$wr.redirect("/");
		}
	}
};

ErrorPage.propTypes = PageStrictPropTypes({
	// optional prop for which type of error page
	which: PropTypes.string,
});

module.exports = ErrorPage;



// WEBPACK FOOTER //
// ./modules/components/technical/ErrorPage.js